var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _circle, _line, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _path, _circle2, _circle3, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundcopy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 288,
    viewBox: "0 0 314 288",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 133.828,
    y: 91.2681,
    width: 86.0663,
    height: 127.681,
    rx: 4.25602,
    fill: "white",
    stroke: "#E52333",
    strokeWidth: 0.945783
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195.777,
    y: 195.777,
    width: 10.4036,
    height: 2.83735,
    fill: "#E52333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.2141,
    y: 46.8163,
    width: 104.982,
    height: 154.163,
    rx: 8.03916,
    fill: "white",
    stroke: "#E52333",
    strokeWidth: 0.945783
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 106.874,
    y: 63.3676,
    width: 74.7169,
    height: 2.83735,
    fill: "#E52333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106.874,
    y: 73.7711,
    width: 73.7711,
    height: 3.78313,
    fill: "#E52333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 106.871,
    y: 86.876,
    width: 16.5478,
    height: 4.13695,
    fill: "#E52333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 172.373,
    y: 86.876,
    width: 8.2739,
    height: 4.13695,
    fill: "#E52333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_1643_23516)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 148.327,
    cy: 113.163,
    r: 35.9398,
    fill: "white",
    fillOpacity: 0.1
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 148.488,
    cy: 113.494,
    r: 34.0482,
    stroke: "#E52333",
    strokeWidth: 3.78313
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 173.882,
    y1: 138.385,
    x2: 183.34,
    y2: 148.789,
    stroke: "#E52333",
    strokeWidth: 4.72892
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 197.669,
    y: 184.428,
    width: 8.51205,
    height: 3.78313,
    fill: "#E52333"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 105.927,
    y: 181.59,
    width: 75.6627,
    height: 2.83735,
    fill: "#E52333"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 106.874,
    y: 171.187,
    width: 73.7711,
    height: 3.78313,
    fill: "#E52333"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 106.874,
    y: 159.837,
    width: 73.7711,
    height: 3.78313,
    fill: "#E52333"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 105.927,
    y: 149.434,
    width: 27.4277,
    height: 2.83735,
    fill: "#E52333"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 197.669,
    y: 105.928,
    width: 8.51205,
    height: 3.78313,
    fill: "#E52333"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 197.669,
    y: 117.277,
    width: 8.51205,
    height: 2.83735,
    fill: "#E52333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.454 173.454C220.475 176.624 220.354 181.642 217.185 184.663C214.015 187.684 208.996 187.564 205.975 184.394L180.44 157.601C177.419 154.432 177.539 149.413 180.709 146.392C183.879 143.371 188.898 143.491 191.919 146.661L217.454 173.454Z",
    fill: "#E52333"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.666,
    cy: 104.509,
    r: 3.31024,
    fill: "#E52333"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.31,
    cy: 112.075,
    r: 3.31024,
    fill: "#E52333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.676 134.011C155.53 133.745 156.017 132.839 155.688 132.008C154.826 129.833 153.561 127.839 151.953 126.134C149.976 124.038 147.535 122.435 144.821 121.45C142.107 120.464 139.193 120.124 136.307 120.454C133.952 120.724 131.668 121.435 129.573 122.545C128.788 122.961 128.571 123.961 129.047 124.712C129.527 125.469 130.528 125.683 131.328 125.278C132.988 124.439 134.784 123.898 136.633 123.686C139.02 123.413 141.43 123.694 143.675 124.509C145.92 125.324 147.939 126.65 149.574 128.384C150.831 129.717 151.835 131.264 152.544 132.949C152.896 133.786 153.809 134.281 154.676 134.011Z",
    fill: "#E52333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_1643_23516",
    x: 102.803,
    y: 67.6392,
    width: 91.0473,
    height: 91.0474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.79197
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1643_23516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1643_23516",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.79197,
    dy: 4.79197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1643_23516"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.79197,
    dy: -4.79197
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.39598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.76 0 0 0 0 0.76 0 0 0 0 0.76 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_1643_23516",
    result: "effect3_innerShadow_1643_23516"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundcopy);
export default __webpack_public_path__ + "static/media/NotFound copy.23aa0b9b01db9d385313ee1f4663f2b6.svg";
export { ForwardRef as ReactComponent };